module.exports = __webpack_public_path__ + "img/bank.51e642d5.svg";